const LAST_LOGIN_KEY = "lastEmailLogin";
const LOGGED_IN_KEY = "loggedIn";
const AVOID_NAVIGATION = "avoidNavigation";
const PASSWORD_EXPIRED = "passwordExpired";

export default class AuthService {
  username = null;

  constructor(bRoot) {
    this.app = "/rest-auth/";
    this.bRoot = bRoot;
    this.email = localStorage.getItem(LAST_LOGIN_KEY);
    localStorage.setItem(LOGGED_IN_KEY, false);
    localStorage.setItem(AVOID_NAVIGATION, false);
    localStorage.setItem(PASSWORD_EXPIRED, false);
    this.loggedIn = false;
    this.avoid_navigation = false;
    this.password_expired = false;
    this.password_expiry_days_left = null;
    this.unseen_account_receivable_movements = 0;
    this.login = this.login.bind(this);
    this.logout = this.logout.bind(this);
    this.registration = this.registration.bind(this);
    this.updateUserState = this.updateUserState.bind(this);
    this.refreshUnseenAccountReceivableMovements = this.refreshUnseenAccountReceivableMovements.bind(
      this
    );
  }

  login(email, password) {
    return Promise.resolve()
      .then(() => {
        if (!(email && password)) {
          throw new Error("Ingrese nombre de usuario y contraseña");
        } else {
          return this.bRoot.axios.post(this.app + "login/", {
            email: email,
            password: password
          });
        }
      })
      .then(response => {
        if (response.data.key) {
          localStorage.setItem(LAST_LOGIN_KEY, email);
          localStorage.setItem(LOGGED_IN_KEY, true);
          this.loggedIn = true;
          return this.bRoot.axios.get(
            "user/applicationinfo/" + this.bRoot.appName + "/"
          );
        } else {
          localStorage.setItem(LOGGED_IN_KEY, false);
          throw "Error desconocido en inicio de sesión";
        }
      })
      .then(async response => {
        if (!response.data.allowed_to_use_api) {
          throw "Usuario no autorizado";
        }
        let appInfoFiltered = this.filterMenuItems(response.data);
        this.bRoot.appInfo = appInfoFiltered;
        this.current_level =
          response.data.commercial_person.commercial_person_type.level;
        this.show_comunication =
          response.data.commercial_person.commercial_person_type.level >= 3
            ? true
            : false;
        this.unreaded_comunications = response.data.comunication_info.unreaded;
        this.avoid_navigation =
          response.data.comunication_info.avoid_navigation ||
          response.data.password_expired;
        localStorage.setItem(AVOID_NAVIGATION, this.avoid_navigation);
        localStorage.setItem(PASSWORD_EXPIRED, response.data.password_expired);
        this.password_expiry_days_left =
          response.data.password_expiry_days_left ?? null;
        this.password_expired = response.data.password_expired ?? false;
        await this.refreshUnseenAccountReceivableMovements(false);
        // avisos según días restantes
        if (this.password_expired) {
          this.bRoot.eventHub.$emit("passwordExpired");
          return true;
        } else if (
          this.password_expiry_days_left !== null &&
          this.password_expiry_days_left <= 10
        ) {
          this.bRoot.eventHub.$emit(
            "passwordExpiryWarning",
            this.password_expiry_days_left
          );
        }
        this.bRoot.eventHub.$emit("logIn");
        return true;
      })
      .catch(error => {
        if (error.response) {
          let errmsg = this.bRoot.responseDataToString(error.response.data);
          if (errmsg === "CSRF Failed: CSRF cookie not set.") {
            this.bRoot.setError("Error en logueo, intente nuevamnte");
            this.bRoot.axios.post("/user/logout/");
          }
        }
        if (!this.bRoot.errors) {
          this.bRoot.setError(error);
        }
        return false;
      });
  }

  async refreshUnseenAccountReceivableMovements(emitRepaint = false) {
    try {
      const response = await this.bRoot.search(
        "/data/account_receivables_unseen_count"
      );
      const parsed = parseInt(response?.data?.count, 10);
      this.unseen_account_receivable_movements = Number.isNaN(parsed)
        ? 0
        : parsed;
    } catch (error) {
      this.unseen_account_receivable_movements = 0;
    } finally {
      if (emitRepaint) {
        this.bRoot.eventHub.$emit("repaint");
      }
    }
  }

  async updateUserState() {
    try {
      let response = await this.bRoot.axios.get(
        "user/applicationinfo/" + this.bRoot.appName + "/"
      );
      this.unreaded_comunications = response.data.comunication_info.unreaded;
      this.avoid_navigation =
        response.data.comunication_info.avoid_navigation ||
        response.data.password_expired;
      await this.refreshUnseenAccountReceivableMovements(false);
      localStorage.setItem(AVOID_NAVIGATION, this.avoid_navigation);
      this.bRoot.eventHub.$emit("logIn");
    } catch (error) {
      if (!this.bRoot.Errors) {
        this.bRoot.setError(error);
      }
    }
  }

  /* eslint-disable */
  filterMenuItems(appInfo) {
    if (appInfo.commercial_person.commercial_person_type.level > 2) {
      let enabled_menu_items = [];

      for (let menu_item of appInfo.enabled_menu_items) {
        if (menu_item.code == "WNVENT") {
          if (
            !appInfo.commercial_person.can_view_orders &&
            !appInfo.commercial_person.can_edit_orders
          ) {
            menu_item = null;
          }
        } else if (menu_item.code == "WCOTIZ") {
          if (
            !appInfo.commercial_person.can_access_quotations
            || (appInfo.commercial_person.commercial_person_type.level == 4 && !appInfo.commercial_person.superior_can_access_quotations)
          ) {
            menu_item = null;
          }
        }
        if (menu_item) {
          enabled_menu_items.push(menu_item);
        }
      }
      appInfo.enabled_menu_items = enabled_menu_items;
    }
    appInfo.enabled_menu_items.push({
      code: 'change_password',
      description: 'Cambiar contraseña',
      component: 'Register',
      params: { mode: 'changePassword' },
      sub_item: []
    });
    return appInfo;
  }
  /* eslint-enable */

  logout() {
    return Promise.resolve()
      .then(() => {
        if (eval(localStorage.getItem(LOGGED_IN_KEY))) {
          return this.bRoot.axios.post("user/logout/");
        }
      })
      .then(() => {
        return true;
      })
      .catch(error => {
        this.bRoot.SetError(error);
        return false;
      })
      .finally(() => {
        localStorage.setItem(LOGGED_IN_KEY, false);
        localStorage.setItem(AVOID_NAVIGATION, false);
        localStorage.setItem(PASSWORD_EXPIRED, false);
        this.loggedIn = false;
        this.bRoot.appInfo = null;
        this.current_level = null;
        this.show_comunication = null;
        this.unreaded_comunications = null;
        this.unseen_account_receivable_movements = 0;
        this.avoid_navigation = false;
        this.bRoot.createConnections();
      });
  }

  async registration(email, password, passwordconf, mode, uid, token) {
    try {
      let endpoint = null;
      let data = null;
      switch (mode) {
        case "register":
          endpoint = "registration/";
          data = {
            email: email,
            password1: password,
            password2: passwordconf
          };
          break;
        case "forgotPassword":
          endpoint = "password/reset/";
          data = {
            email: email
          };
          break;
        case "changePassword":
          endpoint = "password/reset/confirm/";
          data = {
            uid: uid,
            token: token,
            new_password1: password,
            new_password2: passwordconf
          };
          break;
        case "confirmEmail":
          endpoint = "registration/verify-email/";
          data = {
            key: token
          };
          break;
      }
      await this.bRoot.axios.post(this.app + endpoint, data);
      return true;
    } catch (error) {
      if (!this.bRoot.errors) {
        this.bRoot.setError("Error procesando datos. Intente nuevamente");
      }
      return false;
    }
  }
}
